export function useTruck() {
  return {};
}
